export default {
  props: {
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    step: {
      type: Number,
      default: 1,
    },
    value: {},
  },
  data() {
    return {
      sliderValue: this.value,
    }
  },
  methods: {
    setSliderValue(event) {
      this.sliderValue = parseFloat(event.target.value);
    },
    getProgress(value, min, max) {
      return ((value - min) / (max - min)) * 100;
    },
    setCSSProgress(progress) {
      if (!this.$refs.slider) return;
      this.$refs.slider.style.setProperty('--ProgressPercent', `${progress}%`);
    },
  },
  watch: {
    value(value) {
      this.sliderValue = value !== null ? parseFloat(value, 10) : 0;
    },
    sliderValue (value) {
      if (value) {
        this.$emit('input', value);
      }
      const progress = this.getProgress(
        value,
        this.min,
        this.max,
      );
      const extraWidth = (100 - progress) / 10;
      this.setCSSProgress(progress + extraWidth);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/range-slider/range-slider.js